import { render, staticRenderFns } from "./finalreport.vue?vue&type=template&id=2ac57710&"
import script from "./finalreport.vue?vue&type=script&lang=js&"
export * from "./finalreport.vue?vue&type=script&lang=js&"
import style0 from "./finalreport.vue?vue&type=style&index=0&id=2ac57710&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ac57710')) {
      api.createRecord('2ac57710', component.options)
    } else {
      api.reload('2ac57710', component.options)
    }
    module.hot.accept("./finalreport.vue?vue&type=template&id=2ac57710&", function () {
      api.rerender('2ac57710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/greenfilm/finalreport.vue"
export default component.exports